import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
const navLinks = [{
  label: "Strona Główna",
  path: "/HomepagePage"
}, {
  label: "Usługi",
  path: "/ServicesPage"
}, {
  label: "O Nas",
  path: "/AboutUsPage"
}, {
  label: "Kontakt",
  path: "/ContactPage"
}];
const infoItems = [{
  icon: MapPin,
  text: "ul. Marszałkowska 12\n00-001 Warszawa, Polska"
}, {
  icon: Clock,
  text: "Pon. – Pt.\n09:00 – 17:00"
}];
const contactItems = [{
  icon: Phone,
  text: "+48 22 123 45 67"
}, {
  icon: Phone,
  text: "+48 600 700 800"
}, {
  icon: Mail,
  text: "kontakt@bhmarketing.pl"
}];
export default function Twobuttoncalltoaction() {
  return;
}